import { type AppAction, AppActionTypes, type AppState } from 'src/types.ts';

export const reducer = (state: AppState, action: AppAction): AppState => {
    // console.info('Reducer invocation', action);
    switch (action.type) {
        case AppActionTypes.OPEN_DRAWER:
            return { ...state, openDrawer: true } as AppState;
        case AppActionTypes.CLOSE_DRAWER:
            if (state.unsavedChanges) {
                return { ...state, openDrawer: true } as AppState;
            } else {
                return { ...state, openDrawer: false } as AppState;
            }
        case AppActionTypes.CLOSE_BANNER_ON_ERROR:
            return { ...state, bannerClosedOnError: true } as AppState;
        case AppActionTypes.RESET_CLOSE_BANNER_ON_ERROR:
            return { ...state, bannerClosedOnError: false } as AppState;
        case AppActionTypes.ACCEPT_ALL:
            return {
                ...state,
                acceptAll: true,
                eventProcessed: false,
                event: action.mouseEvent,
                optInPersonalizedAdvertising: true,
                optInAnalytics: true,
                optInFunctional: true,
            } as AppState;
        case AppActionTypes.ACCEPT_ALL_COMPLETED:
            return {
                ...state,
                acceptAll: false,
                eventProcessed: true,
                event: null,
                openDrawer: false,
                choicesConfirmedAtleastOnce: true,
                unsavedChanges: false,
                trackingConsentDetails: action.trackingConsentDetails,
            } as AppState;
        case AppActionTypes.ACCEPT_ALL_FAILED:
            return { ...state, isErred: action.isErred, errorMessage: action.errorMessage } as AppState;
        case AppActionTypes.CONFIRM_MY_CHOICES:
            return { ...state, confirmMyChoices: true, eventProcessed: false, event: action.mouseEvent } as AppState;
        case AppActionTypes.CONFIRM_MY_CHOICES_COMPLETED:
            return {
                ...state,
                confirmMyChoices: false,
                eventProcessed: true,
                event: null,
                openDrawer: false,
                isErred: false,
                errorMessage: null,
                choicesConfirmedAtleastOnce: true,
                unsavedChanges: false,
                trackingConsentDetails: action.trackingConsentDetails,
            } as AppState;
        case AppActionTypes.CONFIRM_MY_CHOICES_FAILED:
            return { ...state, isErred: action.isErred, errorMessage: action.errorMessage } as AppState;
        case AppActionTypes.SET_OPT_IN_PERSONALIZED_ADVERTISING:
            return { ...state, optInPersonalizedAdvertising: action.payload } as AppState;
        case AppActionTypes.SET_OPT_IN_PERSONALIZED_ANALYTICS:
            return { ...state, optInAnalytics: action.payload } as AppState;
        case AppActionTypes.SET_OPT_IN_PERSONALIZED_FUNCTIONAL:
            return { ...state, optInFunctional: action.payload } as AppState;
        case AppActionTypes.SET_TRACKING_CONSENT_DETAILS:
            return {
                ...state,
                isErred: false,
                trackingConsentDetails: action.trackingConsentDetails,
                choicesConfirmedAtleastOnce:
                    action.trackingConsentDetails?.confirmed ?? state.choicesConfirmedAtleastOnce,
                optInAnalytics: action.trackingConsentDetails?.purposes?.Analytics ?? state.optInAnalytics,
                optInFunctional: action.trackingConsentDetails?.purposes?.Functional ?? state.optInFunctional,
                optInPersonalizedAdvertising:
                    action.trackingConsentDetails?.purposes?.SaleOfInfo ?? state.optInPersonalizedAdvertising,
            } as AppState;
        case AppActionTypes.SET_TRACKING_CONSENT_DETAILS_FAILED:
            return {
                ...state,
                isErred: true,
                showConsentUI: false,
                trackingConsentDetails: null,
                errorMessage: action.errorMessage,
            } as AppState;
        case AppActionTypes.SET_UNSAVED_CHANGES:
            if (action.unsavedChanges) {
                return {
                    ...state,
                    unsavedChanges: true,
                } as AppState;
            } else {
                return {
                    ...state,
                    isErred: false,
                    errorMessage: null,
                    unsavedChanges: false,
                } as AppState;
            }
        case AppActionTypes.UNSAVED_CHANGES:
            return {
                ...state,
                openDrawer: true,
                isErred: true,
                errorMessage: action.errorMessage,
            } as AppState;
        default:
            throw new Error('Unknown action type');
    }
};
